module.exports = __webpack_public_path__ + "img/telegram.ef85f69c.svg";